/* eslint-disable */
import * as Types from '../../../models/schema.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RefreshTokenVariablesDTO = Types.Exact<{
  refreshToken: Types.Scalars['String'];
}>;


export type RefreshTokenDTO = { __typename?: 'Mutation', refreshToken: { __typename?: 'LoginResult', accessToken: string, refreshToken: string } };


export const RefreshTokenDocumentDTO = gql`
    mutation refreshToken($refreshToken: String!) {
  refreshToken(data: {refreshToken: $refreshToken}) {
    accessToken
    refreshToken
  }
}
    `;
export type RefreshTokenMutationFnDTO = Apollo.MutationFunction<RefreshTokenDTO, RefreshTokenVariablesDTO>;

/**
 * __useRefreshToken__
 *
 * To run a mutation, you first call `useRefreshToken` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshToken` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshToken, { data, loading, error }] = useRefreshToken({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshToken(baseOptions?: Apollo.MutationHookOptions<RefreshTokenDTO, RefreshTokenVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenDTO, RefreshTokenVariablesDTO>(RefreshTokenDocumentDTO, options);
      }
export type RefreshTokenHookResult = ReturnType<typeof useRefreshToken>;
export type RefreshTokenMutationResultDTO = Apollo.MutationResult<RefreshTokenDTO>;
export type RefreshTokenMutationOptionsDTO = Apollo.BaseMutationOptions<RefreshTokenDTO, RefreshTokenVariablesDTO>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    